import { Star } from "lucide-react";

export const Stars = ({ rating, size = 14 }) => (
  <div className="flex gap-0.5" aria-label={`${rating} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        className={i <= rating ? "fill-amber-400 text-amber-400" : "text-slate-600"}
      />
    ))}
  </div>
);
